import { COLORS, FONTS, SIZE } from '@app/src/ui';
import styled from 'styled-components';

export const Wrapper = styled.div`
  background: #F2F7FF;
  height: 42px;
  font-size: 14px;
  font-family: ${FONTS.OPEN_SANS};
  color: ${COLORS.GRAY_DARK};
  padding: 0 15px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) 
    padding: 0;
`;

export const Bold = styled.strong`
  color: #666;
`;

export const Container = styled.div`
  max-width: 480px;
  margin: 0 auto;
  height: 100%;
  display: flex;
  align-items: center;
`;

export const Step = styled.p`
  margin-left: auto;
`;